import React,{useEffect} from "react";
import '../Css/Readmore.css';
import Footer from "./Footer";
import Client from '../Components/Client.json';
import Happyclient from "./Happyclient";
function Readmore(props)
{  
    useEffect((()=>
  {
    document.title ='Home';
  }))
    return(
        <div id="main2">
         <div>
         <header id="heading">
         List of clients who are happy with our service
         </header>
         </div>
         <div id="larger">
         <div id="happyclient">
           {
            Client.map((element,index)=>{
                return(
                   <Happyclient 
                   id={element.id}
                   name={element.name}
                   phone={element.phone}
                   email={element.email}
                   address={element.address}
                   company={element.address}
                   />
                )
            })
           }  

         </div>
         </div>
        <div className="container-fluid" id="foot">
        <div className="row">
        <Footer/>
        </div>
        </div>
        </div>
    )
}
export default Readmore;